import {post} from '@/hook/useAxios'

// 获取用户信息
export const getUserInfo = (data) => {
    return post("/auth/user/currentUserInfo", data);
};

// 获取当前登录用户的菜单和权限
export const getPermissions = (data) => {
    return post("/auth/permission/getPermissions", data);
};

// 获取图形验证码
export const getCaptcha = (data) => {
    return post("/common/captcha", data);
};

// 登录
export const userLogin = (data) => {
    return post("/auth/login", data);
};

// 退出登录
export const userLogout = (data) => {
    return post("/auth/logout", data);
};

// 修改自己的个人信息
export const updateProfile = (data) => {
    return post("/auth/user/updateProfile", data);
};

// 修改自己的密码
export const resetPassword = (data) => {
    return post("/auth/user/resetPassword", data);
};

// 获取省
export const getProvince = (data) => {
    return post("/common/province", data);
};

// 获取市
export const getCity = (data) => {
    return post("/common/city", data);
};

// 获取区
export const getDistrict = (data) => {
    return post("/common/district", data);
};

// 免密登录
export const proxyLogin = (data) => {
    return post("/auth/proxyLogin", data);
};

// 返回代登录账号
export const tokenLogin = (data) => {
    return post("/auth/tokenLogin", data);
};

// 发送短信验证码
export const smsCode = (data) => {
    return post("/common/sms", data);
};

// 忘记密码
export const forgetPassword = (data) => {
    return post("/auth/forgetPassword", data);
};

// 两轮桩 - 根据站点名称查找站点
export const ebikeSitesForSearch = (data) => {
    return post("/common/ebikeSitesForSearch", data);
};

// 汽车桩 - 根据站点名称查找站点
export const carSitesForSearch = (data) => {
    return post("/common/carSitesForSearch", data);
};

// 根据账号查找归属人数据
export const ownerUserForSearch = (data) => {
    return post("/common/ownerUserForSearch", data);
};

// 根据账号查找申请人数据
export const applyUserForSearch = (data) => {
    return post("/common/applyUserForSearch", data);
};

// 根据账号名查询莱充云商家账号
export const lcyUserForSearch = (data) => {
    return post("/common/lcyUserForSearch", data);
};

// 根据站点名称查询莱充云站点
export const lcyEbikeSitesForSearch = (data) => {
    return post("/common/lcyEbikeSitesForSearch", data);
};

// 设备业务类型枚举
export const businessTypes = (data) => {
    return post("/common/businessTypes", data);
};

// 两轮桩设备类型枚举
export const ebikeDeviceTypes = (data) => {
    return post("/common/ebikeDeviceTypes", data);
};

// 两轮桩设备款式枚举
export const ebikeDeviceStyles = (data) => {
    return post("/common/ebikeDeviceStyles", data);
};

// 两轮桩设备协议版本枚举
export const ebikeDeviceProtocols = (data) => {
    return post("/common/deviceProtocols", data);
};

// 汽车桩设备类型枚举
export const carDeviceTypes = (data) => {
    return post("/common/carDeviceTypes", data);
};

// 汽车桩设备款式枚举
export const carDeviceStyles = (data) => {
    return post("/common/carDeviceStyles", data);
};

// 汽车桩设备协议版本枚举
export const carDeviceProtocols = (data) => {
    return post("/common/carDeviceProtocols", data);
};

// 充值机设备类型枚举
export const rechargeDeviceTypes = (data) => {
    return post("/common/depositDeviceTypes", data);
};

// 充值机设备款式枚举
export const rechargeDeviceStyles = (data) => {
    return post("/common/depositDeviceStyles", data);
};

// 充值机设备协议版本枚举
export const rechargeDeviceProtocols = (data) => {
    return post("/common/depositDeviceProtocols", data);
};

// 根据账号查找归属人数据或申请人数据
export const getApplyOrOwnerUserList = (data) => {
    return post("/common/getApplyOrOwnerUserList", data);
};
